import { render, staticRenderFns } from "./UserMachineGroupLabel.vue?vue&type=template&id=36d05758&scoped=true&"
import script from "./UserMachineGroupLabel.vue?vue&type=script&lang=js&"
export * from "./UserMachineGroupLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d05758",
  null
  
)

export default component.exports